export const environment = {
  production: false,
  apiBaseUrl: '/api',
  googleClientId:
    '820674464769-h24u26tur48n8uesliac04pbeig7ct71.apps.googleusercontent.com',
  // '29074426694-q9aegdjsm23tg9cvnalen5d8f0tdk39a.apps.googleusercontent.com',
  cacheLifespanSeconds: 360,
  openWalletUrl: 'https://sequence.app/wallet',
};
